import useSwiperScript from "@/hooks/useSwiperScript";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { isVideoLink } from "../../../util/common";
import { selectCdnImageSettings } from "../../../util/selectors";
import HoverImage from "./hoverImage";

const MainImage = ({
  imageList,
  sliderRef,
  sliderContainerRef,
  handleImageMouseMove,
  zoomedBlockRef,
  handleImageMouseOut,
  activeImageIndex,
  setActiveImageIndex
}) => {
  const videoRefs = useRef([]);
  const configCdnImagesSettings = useSelector(selectCdnImageSettings);
  const [swiper, setSwiper] = useState(null);
  const loadedScriptStatus = useSwiperScript();

  const handleVideo = (currentSlide, nextSlide, children) => {
    const nextVideo = videoRefs.current[nextSlide];
    const currentVideo = videoRefs.current[currentSlide];
    if (children[nextSlide] && children[nextSlide].type === "video") {
      nextVideo.load();
      nextVideo.play();
    } else if (
      children[currentSlide] &&
      children[currentSlide].type === "video"
    ) {
      currentVideo.pause();
    }
  };

  const checkContentUrlType = (item, index, imgUrl) => {
    if (isVideoLink(item)) {
      return (
        <video
          width="100%"
          height="100%"
          controls
          loop
          ref={el => {
            videoRefs.current[index] = el;
          }}
        >
          <source src={`${imgUrl?.main}${item}`} type="video/mp4" />
        </video>
      );
    }
    return (
      <HoverImage
        key={`${index}-${item}`}
        url={imgUrl}
        handleImageMouseMove={handleImageMouseMove}
        handleImageMouseOut={handleImageMouseOut}
        hoverImg={item}
        forwardRef={sliderContainerRef.current}
        zoomedBlockRef={zoomedBlockRef}
      />
    );
  };

  useEffect(() => {
    if (sliderRef.current && (loadedScriptStatus || window.Swiper)) {
      const swiper = new window.Swiper(sliderRef.current, {
        loop: true
      });
      setSwiper(swiper);
      swiper.on("slideChange", e => {
        setActiveImageIndex(e.realIndex);
      });
    }
  }, [sliderRef, loadedScriptStatus]);

  useEffect(() => {
    if (swiper) {
      swiper.slideToLoop(activeImageIndex);
    }
  }, [activeImageIndex, swiper]);

  return (
    <div className="swiper-wrapper thumb-main-gallery">
      <div className="swiper" ref={sliderRef}>
        <div className="swiper-wrapper">
          {imageList?.map((item, index) =>
            checkContentUrlType(item, index, configCdnImagesSettings)
          )}
        </div>
      </div>
    </div>
  );
};

export default MainImage;
